import React from "react";
import { Bot, Server, Users, RefreshCw } from "lucide-react";
import StatusBadge from "@/components/common/StatusBadge";
import { timeAgo } from "@/lib/communities";

export default function DiscordHealthCard({ status }) {
    if (!status) return null;
    const items = [
        { icon: Bot, label: "Discord", value: <StatusBadge status={status.demo_mode ? "demo" : status.connection} testId="discord-sync-status-badge" /> },
        { icon: Bot, label: "Bot", value: <StatusBadge status={status.bot_online ? "online" : "offline"} label={status.bot_online ? "ONLINE" : "OFFLINE"} /> },
        { icon: Server, label: "Guild", value: <span className="font-heading text-lg font-bold text-foreground">{status.guild_name}</span> },
        { icon: Users, label: "Members Synced", value: <span className="font-heading text-lg font-bold text-foreground tabular-nums">{(status.members_synced || 0).toLocaleString()}</span> },
        { icon: RefreshCw, label: "Last Sync", value: <span className="text-sm text-foreground">{timeAgo(status.last_sync)}</span> },
    ];
    return (
        <div data-testid="discord-health-card" className="tactical-card rounded-lg p-5">
            <div className="flex items-center justify-between mb-4">
                <h3 className="font-heading text-xl font-bold uppercase tracking-wide">Discord Integration</h3>
                {status.demo_mode && (
                    <span className="label-mono text-warning border border-warning/40 rounded-sm px-2 py-0.5">
                        DEMO — ADD KEYS TO GO LIVE
                    </span>
                )}
            </div>
            {!status.demo_mode && !status.guild_joined && status.invite_url && (
                <a href={status.invite_url} target="_blank" rel="noreferrer" data-testid="invite-bot-banner"
                    className="mb-4 flex items-center justify-between gap-2 rounded-md border border-danger/50 bg-danger/10 px-3 py-2 hover:bg-danger/20 transition-colors">
                    <span className="text-sm text-danger font-heading uppercase">⚠ Bot is not in your server — roles &amp; alerts won't post yet.</span>
                    <span className="label-mono text-danger underline shrink-0">INVITE BOT →</span>
                </a>
            )}
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                {items.map((it) => (
                    <div key={it.label} className="rounded-md border border-border bg-background/40 p-3">
                        <div className="flex items-center gap-1.5 label-mono text-muted-foreground mb-2">
                            <it.icon size={12} /> {it.label}
                        </div>
                        {it.value}
                    </div>
                ))}
            </div>
        </div>
    );
}
